import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor(private toastr: ToastrService) {}

  showSuccess(message: string, title: string) {
    this.toastr.success(message, title);
  }

  showError(message: string, title: string) {
    this.toastr.error(message, title);
  }

  showInfo(message: string, title: string) {
    this.toastr.info(message, title);
  }

  showWarning(message: string, title: string) {
    this.toastr.warning(message, title);
  }

  // SWEET ALERT
  init() {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
    });
    return Toast;
  }

  messageSuccess(message: any) {
    const Toast = this.init();
    Toast.fire({
      icon: 'success',
      title: `${message}`,
      background: 'green ',
    });
  }

  messageError(message: any) {
    const Toast = this.init();
    Toast.fire({
      icon: 'error',
      title: `${message}`,
    });
  }

  async messageModal(verbo: string, campo: string, forceMessage?: string) {
    const Toast = Swal.fire({
      title: '¿Estás seguro?',
      text:
      !forceMessage ? campo === 'intervalo'
          ? `¿Deseas ${verbo} este ${campo}?`
          : `¿Deseas ${verbo} esta ${campo}?` : forceMessage,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#bb0064',
      cancelButtonColor: '#807d7d',
      confirmButtonText: 'ACEPTAR',
      cancelButtonText: 'CANCELAR',
      reverseButtons: true,
    }).then((result: { isConfirmed: any }) => {
      if (result.isConfirmed) {
        return result.isConfirmed;
      }
    });
    const response = await Toast;
    return response;
  }
}
